//@ts-nocheck
import React from "react";
import FirmPerformanceProposalsController, { Props } from "./FirmPerformanceProposalsController.web";
import { Typography, Grid, Box, withStyles, createStyles, MenuItem } from "@material-ui/core";
import moment from "moment";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withRouter } from "react-router";
import withAlertBox from "../../../../components/src/withAlertBox.Web";
import withToast from "../../../../components/src/withSnackBar.Web";
import withLoader from "../../../../components/src/withLoader.Web";
import withDialog from "../../../../components/src/withDialog.web";
import withConfirmBox from "../../../../components/src/withConfirmBox.Web";
import StorageProvider from "../../../../framework/src/StorageProvider.web";
import MediumBlueField from "../../../../components/src/MediumBlueField.web";
import { commonStyles } from "../commonStyles";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { largeChartOptions } from "../chartOptions";
import { Chart as ChartJS, ArcElement, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js";
import { Line } from "react-chartjs-2";
import { firmPerformanceStyles } from "./FirmPerformanceRevenue.web";

ChartJS.register(ArcElement, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const StyledTableCell = withStyles((theme) => ({
  root: {
    width: (props) => (props.width ? props.width : "auto"),
    position: "relative",
    [theme.breakpoints.down("md")]: {
      padding: "8px",
    },
    "&:first-of-type": {
      borderTopLeftRadius: "0.75rem",
      borderBottomLeftRadius: "0.75rem",
    },
    "&:last-of-type": {
      borderTopRightRadius: "0.75rem",
      borderBottomRightRadius: "0.75rem",
    },
  },
  head: {
    color: theme.palette.text.secondary,
    fontSize: "1.1rem",
    fontWeight: "bold",
    fontFamily: "Nunito Sans",
    border: "none",
    backgroundColor: "#F3F3F3",
    padding: "1.2rem 0rem",
  },
  body: {
    fontSize: "1rem",
    color: theme.palette.text.secondary,
    border: "none",
    fontFamily: "Nunito Sans",
    backgroundColor: "#fff",
    padding: "1.2rem 0rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
    },
  },
}))(TableCell);

const proposalsSentTimePeriodOptions = [
  { name: "Last 12 Months", value: 12 },
  { name: "Last 9 Months", value: 9 },
  { name: "Last 6 Months", value: 6 },
  { name: "Last 3 Months", value: 3 },
];

export class FirmPerformanceProposals extends FirmPerformanceProposalsController {
  constructor(props: Props) {
    super(props);
  }

  async componentDidMount() {
    const token = await StorageProvider.get("authToken");
    const accountId = await StorageProvider.get("accountId");
    this.setState(
      {
        token: token,
        accountId: accountId,
      },
      () => {
        this.getProposalSenttData(this.state.proposalsSentTimePeriod);
      }
    );
  }

  selectChangeHandler = (e) => {
    this.setState({
      proposalsSentTimePeriod: e.target.value,
    });
    this.getProposalSenttData(e.target.value);
  }

  render() {
    const { classes, theme } = this.props;
    return (
      <>
        <Grid
          container
          justifyContent="space-between"
          style={{
            position: "relative",
          }}
        >
          <Grid item xs={11} className={[classes.gridSpacing, classes.sectionHeadings]}>
            <Typography
              variant="h2"
              style={{
                color: theme.palette.text.blue2,
              }}
            >
              Proposals
            </Typography>
          </Grid>

          <Grid item xs={12} className={[classes.gridSpacing, classes.whiteCard]}>
            <Grid container justifyContent="space-between">
              <Grid item xs={12} className={classes.sectionHeadings} container justifyContent="space-between" alignItems="center">
                <Typography
                  variant="h2"
                  style={{
                    color: theme.palette.text.blue2,
                  }}
                  id="page-heading-proposal"
                >
                  Proposal Sent
                </Typography>
                <MediumBlueField
                  onChange={this.selectChangeHandler}
                  select
                  value={this.state.proposalsSentTimePeriod}
                  style={{
                    width: "12%",
                    marginRight: "2rem",
                  }}
                >
                  {proposalsSentTimePeriodOptions.map((opt) => {
                    return (
                      <MenuItem key={opt?.name} value={opt?.value}>
                        {opt?.name}
                      </MenuItem>
                    );
                  })}
                </MediumBlueField>
              </Grid>
              <Grid
                item
                xs={9}
                className={[classes.gridSpacing]}
                style={{
                  paddingLeft: theme.spacing(6),
                }}
              >
                <Box
                  style={{
                    height: "21.875rem",
                  }}
                >
                  <Line plugins={[ChartDataLabels]} data={this.state.lineChartData} options={largeChartOptions} />
                </Box>
              </Grid>

              <Grid item xs={12} className={[classes.gridSpacing]}>
                <Grid container alignItems="center">
                  <Grid item xs={12}>
                    <TableContainer>
                      <Table
                        aria-label="simple table"
                        style={{
                          borderCollapse: "separate",
                          borderSpacing: "0px 8px",
                        }}
                      >
                        <TableHead>
                          <TableRow>
                            <StyledTableCell width="2%" />
                            <StyledTableCell width="20%">Client Names</StyledTableCell>
                            <StyledTableCell width="19%" align="center">
                              Proposal Sent
                            </StyledTableCell>
                            <StyledTableCell width="20%">Date | Time</StyledTableCell>
                            <StyledTableCell width="20%">Missing Signature</StyledTableCell>
                            <StyledTableCell width="19%">Notify</StyledTableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                    </TableContainer>
                  </Grid>

                  <Grid item xs={12} className={[classes.clientListCard]}>
                    <TableContainer>
                      <Table
                        aria-label="simple table"
                        style={{
                          borderCollapse: "separate",
                          borderSpacing: "0px 8px",
                        }}
                      >
                        <TableBody>
                          {this.state.clientList.length > 0 ? (
                            this.state.clientList.map((item, index) => {
                              return (
                                <TableRow key={item?.name} className={classes.clientRow}>
                                  <StyledTableCell width="2%">
                                    <Box
                                      className={classes.clientListColorBar}
                                      style={{
                                        backgroundColor: theme.palette.primary.main,
                                      }}
                                    />
                                  </StyledTableCell>
                                  <StyledTableCell width="20%">
                                    <Typography
                                      noWrap
                                      style={{
                                        maxWidth: "15rem",
                                        fontWeight: "bold",
                                        fontSize: "1.1rem",
                                      }}
                                    >
                                      {item?.name}
                                    </Typography>
                                  </StyledTableCell>
                                  <StyledTableCell
                                    align="center"
                                    style={{
                                      fontWeight: 600,
                                    }}
                                    width="19%"
                                  >
                                    {item?.count}
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{
                                      fontWeight: 600,
                                    }}
                                    width="20%"
                                  >
                                    {item?.date && moment(item?.date).format("MM/DD/YYYY")}
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{
                                      fontWeight: 600,
                                      color: theme.palette.error.main,
                                    }}
                                    width="20%"
                                  >
                                    Pending
                                  </StyledTableCell>
                                  <StyledTableCell
                                    style={{
                                      fontWeight: 600,
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    onClick={this.sendReminderEmail.bind(
                                      this,
                                      item.obsData?.survey_id,
                                      item.obsData?.package_management_id,
                                      item.obsData?.client_information_id
                                    )}
                                    width="19%"
                                  >
                                    Send Reminder Email
                                  </StyledTableCell>
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableRow className={classes.clientRow}>
                              <StyledTableCell align="center" colSpan={5}>
                                <Typography align="center">No data to display</Typography>
                              </StyledTableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="h2" color="textSecondary">
                  Pending Enrollments
                </Typography>
              </Grid>

              <Grid item xs={12} className={classes.gridSpacing}>
                <Grid container alignItems="center">
                  <Grid item xs={12}>
                    <TableContainer>
                      <Table
                        aria-label="simple table"
                        style={{
                          borderCollapse: "separate",
                          borderSpacing: "0px 8px",
                        }}
                      >
                        <TableHead>
                          <TableRow>
                            <StyledTableCell width="2%" />
                            <StyledTableCell width="78%">Name of Packages</StyledTableCell>
                            <StyledTableCell width="20%" align="center">
                              Quantity
                            </StyledTableCell>
                          </TableRow>
                        </TableHead>
                      </Table>
                    </TableContainer>
                  </Grid>

                  <Grid item xs={12} className={[classes.clientListCard]}>
                    <TableContainer>
                      <Table
                        aria-label="simple table"
                        style={{
                          borderCollapse: "separate",
                          borderSpacing: "0px 8px",
                        }}
                      >
                        <TableBody>
                          {this.state.proposalPackagePending.length > 0 ? (
                            this.state.proposalPackagePending?.map((item, index) => {
                              return (
                                <TableRow key={item.name} className={classes.clientRow}>
                                  <StyledTableCell></StyledTableCell>
                                  <StyledTableCell
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "1.1rem",
                                    }}
                                  >
                                    {item?.name}
                                  </StyledTableCell>
                                  <StyledTableCell
                                    align="center"
                                    style={{
                                      fontWeight: 600,
                                    }}
                                  >
                                    {item?.count}
                                  </StyledTableCell>
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableRow>
                              <StyledTableCell width="100%" align="center">
                                <Typography>No Data to display</Typography>
                              </StyledTableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  }
}

const FirmPerformanceProposalsWithRouter = withRouter(FirmPerformanceProposals);
const FirmPerformanceProposalsAlertBox = withAlertBox(FirmPerformanceProposalsWithRouter);
const FirmPerformanceProposalsLoader = withLoader(FirmPerformanceProposalsAlertBox);
const FirmPerformanceProposalsToast = withToast(FirmPerformanceProposalsLoader);
const FirmPerformanceProposalsWithDialog = withDialog(FirmPerformanceProposalsToast);

export default withStyles(
  (theme) =>
    createStyles({
      ...commonStyles(theme),
      ...firmPerformanceStyles(theme),
    }),
  { withTheme: true }
)(withConfirmBox(FirmPerformanceProposalsWithDialog));
